"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextFieldLookalike = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var useField_1 = require("../../hooks/useField");
var common_1 = require("./common");
var ErrorMessage_1 = __importDefault(require("./common/ErrorMessage"));
var Wrapper = styled_components_1.default(common_1.Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  overflow: hidden;\n  padding-right: ", "px;\n  flex-shrink: 0;\n"], ["\n  position: relative;\n  overflow: hidden;\n  padding-right: ", "px;\n  flex-shrink: 0;\n"])), function (props) { return (props.hasIcon ? common_1.fieldHeight : 0); });
var PlaceholderWithIcon = styled_components_1.default(common_1.Placeholder)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  right: ", "px;\n"], ["\n  right: ", "px;\n"])), function (props) { return (props.hasIcon ? common_1.fieldHeight : 0); });
var Label = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var Hint = styled_components_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 0.8em;\n  margin-left: 0.3em;\n  position: relative;\n  top: 0.1em; // adjusts alignment with Label\n"], ["\n  font-size: 0.8em;\n  margin-left: 0.3em;\n  position: relative;\n  top: 0.1em; // adjusts alignment with Label\n"])));
var IconWrapper = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: ", "px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: ", "px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])), common_1.fieldHeight);
var TextField = function (props) {
    var label = props.label, hint = props.hint, icon = props.icon, _a = props.type, type = _a === void 0 ? "text" : _a, disabled = props.disabled;
    var _b = useField_1.useField(props), field = _b[0], meta = _b[1];
    var error = meta.error, touched = meta.touched;
    var showError = Boolean(error && touched);
    var placeholderEl = field.value ? null : (react_1.default.createElement(PlaceholderWithIcon, { hasIcon: !!icon },
        react_1.default.createElement(Label, null, label),
        hint ? react_1.default.createElement(Hint, null,
            "(",
            hint,
            ")") : null));
    var inputEl = react_1.default.createElement(common_1.TextInput, __assign({}, field, { type: type, disabled: disabled }));
    var iconEl = icon ? react_1.default.createElement(IconWrapper, null, icon) : null;
    var lineEl = disabled ? null : react_1.default.createElement(common_1.Line, { hasError: showError });
    var errorEl = showError ? react_1.default.createElement(ErrorMessage_1.default, { children: error }) : null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Wrapper, { hasIcon: !!icon },
            placeholderEl,
            inputEl,
            iconEl,
            lineEl),
        errorEl));
};
exports.default = TextField;
// I honestly don't know why this exists in the designs
exports.TextFieldLookalike = styled_components_1.default(common_1.Box)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  line-height: ", "px;\n  ", ";\n"], ["\n  line-height: ", "px;\n  ", ";\n"])), common_1.fieldHeight, common_1.fieldPaddingStyle);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
